import { defaultColors } from './default';

export const theme: any = {
  bodyBackground: defaultColors.primary3,
  defaultLinkColor: defaultColors.primary5,
  top: {
    heading: defaultColors.primary5,
    text: '#fff',
    play: defaultColors.primary5,
    imagePlaceholder: defaultColors.primary5,
  },
  tile: {
    default: {
      background: defaultColors.primary3Dark,
      backgroundHover: defaultColors.primary5,
      active: defaultColors.primary5,
      activeColor: '#000',
      color: defaultColors.primary5,
      colorHover: '#000',
    },
    viewing: {
      heading: defaultColors.primary5,
      text: '#fff',
      time: '#fff',
    },
    details: {
      county: '#fff',
      address: defaultColors.primary5,
      price: defaultColors.primary5,
      common: '#fff',
      facebook: defaultColors.primary5,
    },
    broker: {
      background: defaultColors.primary3Dark,
      title: '#ddd',
      link: defaultColors.primary5,
      mail: {
        fill: defaultColors.primary5,
        stroke: defaultColors.primary3,
      },
    },
    button: {
      background: defaultColors.primary3Light,
      color: defaultColors.primary5,
      backgroundHover: defaultColors.primary5,
      colorHover: '#000',
    },
  },
  input: {
    font: {
      size: '1rem',
    },
    background: '#4b4b4b',
    color: 'rgb(255, 255, 255)',
    placeholder: '#b0b0b0',
    label: 'rgb(255, 255, 255)',
    labelAfter: 'rgb(100, 100, 100)',
    error: 'rgb(220, 40, 30)',
    padding: '15px',
  },
  buttons: {
    solid: {
      primary: {
        background: defaultColors.primary5,
        color: '#000',
      },
      secondary: {
        color: defaultColors.primary5,
        borderColor: defaultColors.primary5,
      },
      tertiary: {
        color: defaultColors.primary5,
        borderColor: defaultColors.primary5,
      },
    },
    outline: {
      primary: {
        color: '#fff',
        borderColor: defaultColors.primary5,
      },
    },
    underline: {
      primary: {},
      secondary: {},
      tertiary: {},
    },
  },
};
